<template>
    <PageContainer>
        <PageHeader>
            {{ $t('stockCharge.out-stock.index.page_title') }}

            <template #right>
                <CreateButton class="btn-sm" href="/stockCharge/out-stock/create" />
            </template>
        </PageHeader>

        <SearchPanel
            :search="search"
            url="/stockCharge/out-stock"
            :only="['logs', 'search']"
        />

        <base-table>
            <template #thead>
                <th>{{ $t('stockCharge.out-stock.product_name') }}</th>
                <th>{{ $t('stockCharge.out-stock.size') }}</th>
                <th>{{ $t('stockCharge.out-stock.quantity') }}</th>
                <th>{{ $t('user.email') }}</th>
                <th>{{ $t('stockCharge.out-stock.created_at') }}</th>
                <th></th>
            </template>
            <tr v-for="log in pagination.data" class="align-middle">
                <td>{{ log.product.name }}</td>
                <td>{{ log.product_size.size }}</td>
                <td>{{ log.quantity_added }}</td>
                <td>{{ log.user.email }}</td>
                <td>{{ log.created_at }}</td>
                <td class="text-end">
                    <PreviewButton class="btn-sm" :href="`/stockCharge/out-stock/${log.id}`" />
                </td>
            </tr>
        </base-table>

        <Pagination
            :pagination="pagination.pagination"
        />
    </PageContainer>
</template>

<script setup lang="ts">
import BaseTable from "@/components/elements/BaseTable.vue";
import Pagination from "@/components/elements/Pagination.vue";
import type {PaginatedResponse, StockChargeLogInterface} from "@/components/helpers/Interfaces.ts";
import {usePagination} from "@/Composable/usePagination.ts";
import PageHeader from "@/components/elements/PageHeader.vue";
import PageContainer from "@/components/elements/PageContainer.vue";
import SearchPanel from "@/components/elements/SearchPanel.vue";
import CreateButton from "@/components/buttons/CreateButton.vue";
import PreviewButton from "@/components/buttons/PreviewButton.vue";

const { logs, search = null } = defineProps<{
    logs: PaginatedResponse<StockChargeLogInterface>,
    search?: string
}>()

const pagination = usePagination<StockChargeLogInterface>(logs)
</script>

<style scoped>

</style>
